import { Device } from "../Common/Types/types";
import httpClient from "../Core/http";

class DeviceListAPi {
  getMachineDeviceList(params: any): Promise<any> {
    let url = "machine/deviceList";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const DeviceListApi = new DeviceListAPi();
